/**
 * Created by jv on 2020-01-07 (10:14).
 */
//js
const log = require("Sources/utils/logger")();
import Shared from "Sources/shared";
import LanguageManager from "Sources/services/language-manager";
import utils from "Sources/utils/utils";

//Styles
require("Styles/pages/legal/disclaimer.scss");

// Partial views
const htmlReq = require.context("Views/legal/partials", true, /disclaimer\.html$/);

$(function () {
  Shared.shouldSetUpCreditsDialog = false;
  Shared.init();
  DisclaimerPage.init();
});

let DisclaimerPage = {};

((DisclaimerPage) => {
  DisclaimerPage.init = function () {
    setUpHtmlPartial();
  };

  function setUpHtmlPartial() {
    let htmlRequire = `./${LanguageManager.getCurrentLocale()}/disclaimer.html`;
    let htmlPartial;

    let defaultRequire = "./default/disclaimer.html";

    if (htmlReq.keys().includes(htmlRequire)) {
      htmlPartial = htmlReq(htmlRequire);
      $("#disclaimer-content").html(htmlPartial);
    } else if (htmlReq.keys().includes(defaultRequire)) {
      htmlPartial = htmlReq(defaultRequire);
      $("#disclaimer-content").html(htmlPartial);
    } else {
      log.error("Couldn't find html partial [%s] in known html partial list: %o", htmlRequire, htmlReq.keys());
      utils.redirect("/");
    }
  }
})(DisclaimerPage);



// WEBPACK FOOTER //
// ./app/js/entries/legal/disclaimer.js